import i18n from '@/i18n';
import { IssueSorterColumn } from '@/presentation/components/issue-table/hooks/useSorter';
import { IssueFilterParams } from '@/presentation/store/issue';

export const INIT_FILTER_PARAMS: IssueFilterParams = {
  searchType: 'errorType',
  sortField: IssueSorterColumn.UploadTime,
  sortOrder: 'desc',
  appInBacks: [''],
};

export const DEFAULT_EXCEPTION_TYPE_LIST = 'Crash,Native,ExtensionCrash'; // ios 去掉 native 安卓 没有ExtensionCrash

export const DEFAULT_EXCEPTION_TYPE_LIST_IOS = 'Crash,ExtensionCrash';

export const DEFAULT_EXCEPTION_TYPE_LIST_ANDROID = 'Crash,Native';

export const DEFAULT_EXCEPTION_TYPE_LIST_HARMONY = 'Crash,Native';

export const EXCEPTION_TYPE_LIST = {
  crash: DEFAULT_EXCEPTION_TYPE_LIST,
  anr: 'ANR',
  error: 'AllCatched,Unity3D,Lua,JS',
  crashes: DEFAULT_EXCEPTION_TYPE_LIST,
  blocks: 'ANR',
  errors: 'AllCatched,Unity3D,Lua,JS',
  flutterrors: 'Dart',
};

export const ANDROID_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: i18n.t('所有'), value: DEFAULT_EXCEPTION_TYPE_LIST_ANDROID },
  { label: i18n.t('Java崩溃'), value: 'Crash' },
  { label: i18n.t('Native崩溃'), value: 'Native' },
];

export const HARMONY_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: i18n.t('所有'), value: DEFAULT_EXCEPTION_TYPE_LIST_HARMONY },
  { label: i18n.t('JS崩溃'), value: 'Crash' },
  { label: i18n.t('Native崩溃'), value: 'Native' },
];

export const IOS_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: i18n.t('所有'), value: DEFAULT_EXCEPTION_TYPE_LIST_IOS },
  { label: i18n.t('App崩溃'), value: 'Crash' },
  { label: i18n.t('Extension崩溃'), value: 'ExtensionCrash' },
];

export const ANR_EXCEPTION_TYPE_LIST_OPTIONS = [{ label: 'ANR', value: 'ANR' }];

export const ERROR_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: i18n.t('所有'), value: EXCEPTION_TYPE_LIST.error },
  { label: i18n.t('自定义错误'), value: 'AllCatched' },
  { label: i18n.t('C#脚本错误'), value: 'Unity3D' },
  { label: i18n.t('Lua脚本错误'), value: 'Lua' },
  { label: i18n.t('JS脚本错误'), value: 'JS' },
];

export const ERROR_FLUTTER_EXCEPTION_TYPE_LIST_OPTIONS = [
  { label: i18n.t('Dart错误'), value: 'Dart' },
];

export enum IssueStatus {
  All = 'all',
  UnProcessed = '0',
  Processed = '1',
  Processing = '2',
  ToTapd = '6'
}

export enum TextMatchRule {
  Equal = '',
  Contains = 'MATCH',
  StartWith = 'PREFIX',
  EndWith = 'SUFFIX',
  LessThan = 'LT'
}

export const REPORT_ISSUE_FORM_LABEL: { [key: string]: string} = {
  // 通用
  timeQuick: i18n.t('时间范围'),
  tapdStatus: i18n.t('提单状态'),
  tagColor: i18n.t('标签颜色'),
  osVersion: i18n.t('系统版本'),
  bizExtendInfo: i18n.t('自定义字段'),
  bundleId: 'Bundle ID',
  processName: i18n.t('出错进程'),
  maxAppVersion: i18n.t('APP版本'),
  minAppVersion: i18n.t('APP版本'),
  wildcardAppVersion: i18n.t('APP版本'),

  // 质量
  version: i18n.t('APP版本'),
  contectInfo: i18n.t('用户ID'),
  deviceId: i18n.t('设备ID'),
  detail: i18n.t('出错堆栈'),
  appInBack: i18n.t('前后台状态'),
  launchTimeMax: i18n.t('使用时长（秒）'),
  deviceType: i18n.t('设备类型'),
  platform: i18n.t('平台'),
  status: i18n.t('处理状态'),
  processor: i18n.t('处理人'),
  newTagList: i18n.t('标签'),
  channelId: i18n.t('渠道'),
  cpuArch: i18n.t('运行时架构'),
  cpuArchitecture: i18n.t('CPU架构'),
  issueId: 'Issue ID',
  crashId: i18n.t('消息ID'),
  errorType: i18n.t('异常名称'),
  hardware: i18n.t('机型'),
  threadName: i18n.t('出错线程'),

  // 性能
  appVersionGroup: i18n.t('APP版本'),
  appVersionMode: i18n.t('版本类型'),
  ground: i18n.t('前后台状态'),
  scene: i18n.t('场景'),
  accountId: i18n.t('用户ID'),
  clientIdentify: i18n.t('消息ID'),
  costTimeAvgMax: i18n.t('卡顿平均耗时(毫秒) max'),
  costTimeAvgMin: i18n.t('卡顿平均耗时(毫秒) min'),
  feature: 'Issue ID',
  funcName: i18n.t('问题特征'),
  issueStatus: i18n.t('处理状态'),
  model: i18n.t('机型'),
  monitoredThreadName: i18n.t('监控线程'),
  qimei: i18n.t('设备ID'),
  sdkVersion: i18n.t('SDK版本'),
  systemStack: i18n.t('系统堆栈'),
  tags: i18n.t('标签'),
  tapdHandler: i18n.t('处理人'),
  topNum: i18n.t('Top问题数'),
  userCustom: i18n.t('自定义维度'),
  leakBytesMax: i18n.t('最大泄漏内存(KB) max'),
  leakBytesMin: i18n.t('最大泄漏内存(KB) min'),
  fdType: i18n.t('FD类型'),
  activityName: i18n.t('页面'),
  showType: i18n.t('视图类型'),
  launchTags: i18n.t('自定义tag'),
  maxLaunchCost: i18n.t('启动耗时max'),
  minLaunchCost: i18n.t('启动耗时min'),
  maxSpanCost: i18n.t('Span耗时max'),
  minSpanCost: i18n.t('Span耗时min'),
  avgMaxMallocSize: i18n.t('最大分配堆栈均值（MB）'),
  docCount: i18n.t('影响次数'),
  maxMallocSize: i18n.t('最大分配堆栈范围（MB）'),
  p50MaxMallocSize: i18n.t('分配内存P50（MB）'),
  p90MaxMallocSize: i18n.t('分配内存P90（MB）'),
  qimeiCount: i18n.t('影响设备数'),
  usedMem: i18n.t('FOOM前内存（MB）'),
};
